<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import {dyData} from 'general/store';
    import {BACKGROUND_COLOR, TEMPLATE} from 'general/constants';
    import Form from 'general/components/form/email/Form.svelte';
    import CartImages from '../../components/cartImages/CartImages.svelte';
    import CartIcon from '../../icons/Cart.svelte';
    import Description from 'general/components/description/Description.svelte';
    import OpacityItem from 'general/components/flip/opacityItem/OpacityItem.svelte';

    import s from './style.module.css';
    import Policy from 'general/components/policy/Policy.svelte';

    export let instance: AxiosInstance;

    const isLight = $dyData.side.main?.backgroundColor === BACKGROUND_COLOR.LIGHT;
</script>

<OpacityItem delayIn={0}>
    <div
        class={s.main}
        class:s.light={isLight}
        class:s.colored={!isLight}
        style="margin-top: {$dyData.side.main?.marginTop || 0}"
    >
        <div class={s.cartIcon}>
            <CartIcon />
        </div>
        <Description template={TEMPLATE.SQUARE_EXIT_CART} value={$dyData.description.main} />
        <Form
            {instance}
            label="Your Email"
            offerGiven={$dyData.offerGiven}
            template={TEMPLATE.SQUARE_EXIT_CART}
        />

        <div class={s.wrapper}>
            <CartImages />
            <Policy padding="163px 77px 0px" />
        </div>
    </div>
</OpacityItem>
